import React from 'react';
import { inject, observer } from 'mobx-react';
import s from './index.less';
import ViewBox, { viewBoxType } from '../ViewBox';

interface BoxOrderProps {
  members: Array<any>;
}

// 行/列数表，与 QML GridLayoutPage.qml layoutParam 保持一致
// 索引 = 人数 - 1
const LAYOUT_PARAM = [
  { rows: 1, columns: 1 }, // 1人
  { rows: 1, columns: 2 }, // 2人
  { rows: 2, columns: 3 }, // 3人
  { rows: 2, columns: 2 }, // 4人
  { rows: 2, columns: 3 }, // 5人
  { rows: 2, columns: 3 }, // 6人
  { rows: 3, columns: 3 }, // 7人
  { rows: 3, columns: 3 }, // 8人
  { rows: 3, columns: 3 }, // 9人
];

// positions[index] = [colOffset, rowIndex]，colOffset 为小数时表示该行居中偏移
// 与 QML GridLayoutPage.qml positionParam 保持一致
const POSITION_PARAM = [
  // 1人
  [[0, 0]],
  // 2人
  [[0, 0], [1, 0]],
  // 3人：行1两卡居中，行2一卡居中
  [[0.5, 0], [1.5, 0], [1, 1]],
  // 4人
  [[0, 0], [1, 0], [0, 1], [1, 1]],
  // 5人：行1三卡，行2两卡居中
  [[0, 0], [1, 0], [2, 0], [0.5, 1], [1.5, 1]],
  // 6人
  [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1]],
  // 7人：3+3+1，末行居中
  [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1], [1, 2]],
  // 8人：3+3+2，末行居中
  [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1], [0.5, 2], [1.5, 2]],
  // 9人
  [[0, 0], [1, 0], [2, 0], [0, 1], [1, 1], [2, 1], [0, 2], [1, 2], [2, 2]],
];

const GAP_PX = 4;

// cell 宽度: calc(100%/cols - (cols-1)*4px/cols)
function cellWidth(cols: number): string {
  const pct = 100 / cols;
  const px = ((cols - 1) * GAP_PX) / cols;
  return px === 0 ? '100%' : `calc(${pct}% - ${px}px)`;
}

// cell 高度: calc(100%/rows - (rows-1)*8px/rows)
function cellHeight(rows: number): string {
  const pct = 100 / rows;
  const px = ((rows - 1) * GAP_PX) / rows;
  return px === 0 ? '100%' : `calc(${pct}% - ${px}px)`;
}

// left: calc(colOffset/cols*100% + colOffset*8px/cols)
function cellLeft(colOffset: number, cols: number): string {
  if (colOffset === 0) return '0';
  const pct = (colOffset / cols) * 100;
  const px = (colOffset * GAP_PX) / cols;
  return `calc(${pct}% + ${px}px)`;
}

// top: calc(rowIndex/rows*100% + rowIndex*8px/rows)
function cellTop(rowIndex: number, rows: number): string {
  if (rowIndex === 0) return '0';
  const pct = (rowIndex / rows) * 100;
  const px = (rowIndex * GAP_PX) / rows;
  return `calc(${pct}% + ${px}px)`;
}

const BoxOrder: React.FC<BoxOrderProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
  };
})(
  observer((props: BoxOrderProps) => {
    const { members } = props;
    const cardLen = members?.length;
    if (!cardLen || cardLen < 1 || cardLen > 9) return null;

    const layout = LAYOUT_PARAM[cardLen - 1];
    const positions = POSITION_PARAM[cardLen - 1];
    const { rows, columns } = layout;

    return (
      <div className={s.container}>
        {members.map((yxuid, index) => {
          const [colOffset, rowIndex] = positions[index] as [number, number];
          return (
            <div
              key={yxuid}
              className={s.cell}
              style={{
                left: cellLeft(colOffset, columns),
                top: cellTop(rowIndex, rows),
                width: cellWidth(columns),
                height: cellHeight(rows),
              }}
            >
              <ViewBox yxuid={yxuid} type={viewBoxType.video} />
            </div>
          );
        })}
      </div>
    );
  })
);
export default BoxOrder;
